import { load } from "common/loader";
import { delay, delaySound } from "common/promises";
import { onVideoTime } from "common/video";
import log from "loglevel";
import { Scene } from "third-animation/scene/main";
import { resourcePaths } from "third-animation/scene/resources";
import { loadSound } from "third-animation/scene/resources/sound";
import { Param } from "../common";
export async function start({ context, input, }) {
    let audioSrc = "";
    await load({
        onAudio: (src) => {
            audioSrc = src;
        },
        filePaths: resourcePaths,
    });
    const sound = await loadSound(audioSrc);
    const { videoElem, progressElem } = await input.waiter.wait();
    $(videoElem).hide();
    progressElem.fadeOutAndHide();
    context.interactionVideoLoader.clearMovie("3번 영상.mp4");
    context.interactionVideoLoader.runWhenLoaded("5번 영상.mp4", async (elem) => {
        log.info("fifthvideo loaded elem is ", elem);
        videoElem.setAttribute("src", elem.src);
        videoElem.load();
    });
    const scene = new Scene();
    await scene.start({ sound, parentSelector: "#all-container" });
    await context.interactionVideoLoader.wait("5번 영상.mp4");
    $(videoElem).show();
    $(progressElem).show();
    await videoElem.play();
    progressElem.run({ index: 4, video: videoElem });
    // 마지막 사운드가 좀 더 오래 재생되게 만듬
    await delaySound(3000);
    sound.dispose();
    const ret = new Param();
    onVideoTime({
        videoElement: videoElem,
        timeMillis: (videoElem.duration - 1) * 1000,
        callback: () => {
            progressElem.fadeOutAndHide();
        },
    });
    $(videoElem).one("ended", () => {
        ret.fill({ videoElem, progressElem });
    });
    return ret;
}
export async function skippedStart({ context, input, waitVideo, }) {
    log.debug("wait fourth video end in skipped");
    const { videoElem, progressElem } = await input.waiter.wait();
    $(videoElem).hide();
    progressElem.fadeOutAndHide();
    context.interactionVideoLoader.runWhenLoaded("5번 영상.mp4", async (elem) => {
        log.info("fifthvideo loaded elem is ", elem);
        videoElem.setAttribute("src", elem.src);
        videoElem.load();
    });
    await context.interactionVideoLoader.wait("5번 영상.mp4");
    $(videoElem).show();
    $(progressElem).show();
    await videoElem.play();
    progressElem.run({ index: 4, video: videoElem });
    const ret = new Param();
    if (waitVideo) {
        await delay(1000);
        videoElem.currentTime = videoElem.duration - 4;
        onVideoTime({
            videoElement: videoElem,
            timeMillis: (videoElem.duration - 1) * 1000,
            callback: () => progressElem.fadeOutAndHide(),
        });
        $(videoElem).one("ended", () => {
            ret.fill({ videoElem, progressElem });
        });
    }
    else {
        ret.fill({ videoElem, progressElem });
    }
    return ret;
}
//# sourceMappingURL=main.js.map